import { Sailboat } from "lucide-react";
import Reveal from "./Reveal";

export default function Community() {
  return (
    <section id="community" className="bg-ivory py-20 sm:py-24" data-testid="community-section">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20">
        <Reveal className="relative order-1">
          <div className="border border-hairline bg-white p-1.5">
            <img
              src="/loshrs-sponsor.png"
              alt="Will French and Corrie Harding-Keizs holding the Lake Ontario Short Handed Racing Series title sponsor flag"
              data-testid="community-image"
              className="aspect-[3/4] w-full object-cover"
            />
          </div>
          <span className="absolute -bottom-3 -left-3 hidden h-24 w-24 border-b-2 border-l-2 border-gold sm:block" />
        </Reveal>

        <div className="order-2">
          <Reveal>
            <p className="mb-4 text-[11px] font-semibold uppercase tracking-[0.3em] text-ink">
              In the Community
            </p>
            <h2 className="font-serif text-3xl font-medium tracking-tight text-ink sm:text-4xl lg:text-5xl">
              Title sponsor — Lake Ontario Short Handed Racing Series.
            </h2>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-7 space-y-5 text-[15px] font-light leading-relaxed text-smoke sm:text-base">
              <p>
                Will is the title sponsor of the Lake Ontario Short Handed Racing Series (LOSHRS) out
                of the Port Credit Yacht Club — supporting the short-handed offshore racing
                community on the lake he calls home waters.
              </p>
              <p>
                A passionate sailor himself, Will spends his time off aboard his boat, Entourage.
                The partnership brings together two things he loves: the water and the Mississauga
                waterfront community he serves every day.
              </p>
            </div>
            <span
              className="mt-7 inline-flex items-center gap-2 border border-gold px-4 py-2.5 text-[10px] font-semibold uppercase tracking-[0.24em] text-ink"
              data-testid="community-sponsor-badge"
            >
              <Sailboat size={13} className="text-ink" />
              Title Sponsor · LOSHRS — Port Credit Yacht Club
            </span>
          </Reveal>
        </div>
      </div>
    </section>
  );
}